import { Link } from 'react-router-dom';
import { events } from '@/mocks/events';
import { materialMeta, statusStyle } from '@/utils/content';

export default function Focus() {
  const featured = events[0];
  const updates = events.slice(1, 5);

  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3">
        <div>
          <p className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <span className="inline-block w-8 border-t-2 border-primary-500"></span>重点档案
          </p>
          <h2 className="mt-3 font-display font-black text-foreground-950 text-2xl md:text-3xl">
            本周焦点追踪
          </h2>
        </div>
        <Link
          to="/archive"
          className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap"
        >
          进入完整证据库 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-9 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* 焦点大卡 */}
        <Link
          to={`/event/${featured.slug}`}
          className="lg:col-span-2 group relative rounded-lg overflow-hidden min-h-[380px] md:min-h-[440px] flex flex-col justify-end"
        >
          <img
            src={featured.cover}
            alt={featured.title}
            title={`${featured.title} · 重点档案`}
            className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
          <div className="relative p-5 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 text-xs text-background-50 bg-background-950/50 px-2.5 py-1 rounded-full">
                {featured.category}
              </span>
              <span className={`inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full ${statusStyle[featured.status]}`}>
                {featured.status}
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-background-100 bg-background-950/50 px-2.5 py-1 rounded-full">
                <i className="ri-time-line"></i>{featured.time}
              </span>
            </div>
            <h3 className="mt-3 font-display font-black text-background-50 text-2xl md:text-3xl leading-snug group-hover:text-secondary-200 transition-colors">
              {featured.title}
            </h3>
            <p className="mt-2 text-background-100/90 text-sm md:text-base leading-relaxed max-w-2xl">
              {featured.summary}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-background-200">
              {featured.materials.slice(0, 3).map((m) => {
                const mm = materialMeta[m.type];
                return (
                  <span key={m.title} className="inline-flex items-center gap-1.5">
                    <i className={`${mm.icon} text-secondary-300`}></i>
                    {mm.label}
                  </span>
                );
              })}
              <span className="ml-auto inline-flex items-center gap-1 font-medium text-background-50">
                查看全部素材 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </Link>

        {/* 补档动态 */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between px-1">
            <h3 className="font-display font-bold text-foreground-950">最新补档动态</h3>
            <span className="inline-flex items-center gap-1 text-xs text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
              <i className="ri-loader-4-line"></i>持续更新
            </span>
          </div>
          <ul className="space-y-3">
            {updates.map((e) => {
              const last = e.timeline[e.timeline.length - 1];
              return (
                <li key={e.slug}>
                  <Link
                    to={`/event/${e.slug}`}
                    className="group flex gap-3 bg-background-50 border border-background-200 rounded-lg p-4 hover:border-accent-300 hover:bg-background-100/50 transition-colors"
                  >
                    <div className="flex flex-col items-center shrink-0">
                      <span className="w-2.5 h-2.5 rounded-full bg-accent-500 mt-1"></span>
                    </div>
                    <div className="min-w-0">
                      <p className="font-medium text-foreground-950 text-sm leading-snug group-hover:text-accent-700 transition-colors">
                        {e.title}
                      </p>
                      <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                        <i className="ri-refresh-line mr-1"></i>{last.text}
                      </p>
                      <p className="mt-1.5 text-[11px] text-foreground-400">
                        {last.time} · {e.category}
                      </p>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}